import { combineReducers } from 'redux';

import screenReducer from './reducers/screenReducer';
import gameDetailsReducer from './reducers/gameDetailsReducer';
import screenPositionReducer from './reducers/screenPositionReducer';

const reducers = combineReducers({
  screen: screenReducer,
  gameDetails: gameDetailsReducer,
  screenPosition: screenPositionReducer,
});

export default reducers;
